import React, { useContext } from 'react';
import TrainResultItem from '../TrainResultItem';

// Context & Actions
import { TrainsContext } from '../../../TrainsContext';

const TrainResultsList = () => {
  const { state } = useContext(TrainsContext);

  return (
    <React.Fragment>
      {state.filteredTrains.map((train: object, i: number) => {
        return (
          <TrainResultItem
            key={i}
            train={train}
            endingPoint={state.endingPoint}
            startingPoint={state.startingPoint}
            index={i}
          />
        );
      })}
    </React.Fragment>
  );
};

export default TrainResultsList;
